import { render, staticRenderFns } from "./Screen404.vue?vue&type=template&id=59ba0824&scoped=true"
import script from "./Screen404.vue?vue&type=script&lang=js"
export * from "./Screen404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba0824",
  null
  
)

export default component.exports